<template>
    <div :class="showModal ? 'block' : 'hidden'">
        <div class="fixed inset-x-0 bottom-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
            <div class="fixed inset-0 transition-opacity">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <div class="overflow-hidden transition-all transform rounded-lg shadow-xl bg-primary sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <div class="px-4 pt-5 pb-4 bg-primary sm:p-6 sm:pb-4">
                    <div class="sm:flex sm:items-start">
                        <slot></slot>
                    </div>
                </div>
                <div class="mx-4 my-3">
                    <BaseButton @click.native="close()" class="py-2 mb-4 font-medium normal-case">
                        {{ _('modal_close_button') }}
                    </BaseButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
    components: {
        BaseButton,
    },
    data() {
        return {
            showModal: false,
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            _: 'localisation/translate',
        }),
    },
    methods: {
        close() {
            this.showModal = false
        },
    },
    mounted() {
        this.showModal = this.show
    },
    watch: {
        show: {
            handler(value) {
                this.showModal = value
            },
        },
    },
}
</script>
